export const ReceiptInfoConfig = [
  {
    name: "Business",
    fields: [
      {
        id: Math.random() * 10,
        name: "Type_Of_Payment",
        label: "Type Of Payment",
        type: "inputdrop",
        dropdowncontent: ["IFT", "NEFT", "IMPS", "RTGS"],
        autoFocus: true,
      },
      {
        id: Math.random() * 10,
        name: "Amount",
        label: "Amount",
        type: "number",
        min: 0,
        max: 9,
      },
      {
        id: Math.random() * 10,
        name: "UTR_Number",
        label: "UTR Number",
        type: "text",
      },
      {
        id: Math.random() * 10,
        name: "Status",
        label: "Status",
        type: "checkbox",
        min: 0,
        max: Infinity,
      },
    ],
  },
  {
    name: "Documents",
    label: "Other Details",
    fields: [
      {
        id: Math.random() * 10,
        name: "Payment_ScreenShot",
        label: "Payment Screenshot",
      },
    ],
  },
];
